 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		79: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "legacy-" + {"0":"055c360","1":"4371dc9","2":"4996a11","3":"dd048e2","4":"dae9514","5":"732c946","6":"b07ca88","7":"e765139","8":"b3aa14f","9":"25b0eed","10":"c7703bc","12":"016f8f1","13":"32f928b","14":"3bf4305","15":"fed3cd1","17":"57c5604","18":"de4055d","19":"fb85fde","20":"648d889","21":"608dd19","22":"e719674","23":"c1731a0","24":"8124a2b","25":"ea13b77","26":"ac5e127","27":"812745e","28":"0a8d9bb","29":"26ea11c","30":"7d586d7","31":"ccdca81","32":"0acbb7b","33":"12465b2","34":"b32a181","35":"6d609f1","36":"27fd3c5","37":"a84eece","38":"87bd072","39":"47044e8","40":"a6b0384","41":"0c46f5e","42":"2424213","43":"e1734e7","44":"0840ed1","45":"fd4bec6","46":"a605954","47":"a251e8a","48":"32f3a62","49":"1f82c2f","50":"229fa7d","51":"9a2c1c0","52":"3329e89","53":"baf1258","54":"8e9fd9d","55":"fa44b24","56":"ecf9e9f","57":"23a0c85","58":"35fbd27","59":"6f078f6","60":"d93d757","61":"1834141","62":"2ee75b7","63":"e992658","64":"24736a6","65":"50f9d74","66":"e19ead6","67":"1dec8e1","68":"884aacb","69":"53d3d22","70":"cd6cdbd","71":"47df90e","72":"bc8a69a","73":"0ea7766","74":"3c349c2","75":"17f837e","76":"3aee7e6","77":"7a89c0d","78":"ef932c9","80":"42489e5","81":"1c8b17e","82":"24f5484","83":"330fe7e","84":"a748f34","86":"0fc1b4e","87":"ee26a7f","88":"998e68e","89":"35f61fd"}[chunkId] + "-" + ({"0":"pages/__pages/_slug/p/_case_device_pages/c/_uuid_pages/capinhas-para-celular/_slug_pages/cart/index__83c227f8","1":"pages/__pages/_slug/p/_case_device_pages/c/_uuid_pages/capinhas-para-celular/_slug_pages/cart/index__8e47ba5b","2":"vendors_pages/__pages/_slug/p/_case_device_pages/black-friday_pages/capinhas-para-celular/_slug_page_cf13aa03","3":"pages/__pages/capinhas-para-celular/_slug_pages/copolife_pages/iphone15_pages/orders/index_pages/sam_4d3f7e46","4":"vendors_pages/_slug/p/_case_device_pages/c/_uuid_pages/cart/index_pages/kits/_kit/index_pages/orders_938c8969","5":"pages/c/_uuid_pages/kits/_kit/index_pages/update-order-items/_number_pages/update-order-items/editab_7dec9da6","6":"auth-box","7":"custom-engine-input_pages/update-order-items/_number","8":"footer","9":"pages/addresses/_address_id/edit/index_pages/addresses/new/index","10":"pages/update-order-items/editable-line-item/editable-line-item-form/EditableLineItemForm","12":"brand-device-selector","13":"brand-icons","14":"catalog-modal","15":"clutch-specifications","17":"commons_gallery-component","18":"custom-engine-input","19":"drawer-menu","20":"global-device-selector","21":"go-for-good-tabs","22":"grouped-products","23":"hero-banner","24":"home-widget","25":"license-banners","26":"middle-modal","27":"pages/_","28":"pages/_slug/p/_case_device","29":"pages/account/edit/index","30":"pages/account/index","31":"pages/addresses/_address_id/edit/index","32":"pages/addresses/index","33":"pages/addresses/new/index","34":"pages/admin","35":"pages/black-friday","36":"pages/c/_uuid","37":"pages/capinhas-para-celular/_slug","38":"pages/cart/index","39":"pages/category-filters/_slug","40":"pages/central-de-ajuda","41":"pages/collections/_slug","42":"pages/complete-registration/index","43":"pages/contact-us","44":"pages/copolife","45":"pages/finalized-order","46":"pages/find-order/index","47":"pages/go-for-good/index","48":"pages/iphone15","49":"pages/iphone16","50":"pages/kits/_kit/index","51":"pages/kits/index","52":"pages/landing-gifts/index","53":"pages/login","54":"pages/onde-encontrar/index","55":"pages/orders/_number/index","56":"pages/orders/_number/tracking/_track_number","57":"pages/orders/index","58":"pages/protocols/_number/index","59":"pages/protocols/index","60":"pages/redirect-by-device","61":"pages/review-request-high-rating","62":"pages/reviews","63":"pages/rewards/index","64":"pages/samsungs24","65":"pages/search/index","66":"pages/shopinsta/index","67":"pages/signup/index","68":"pages/smartphone-cases/_slug","69":"pages/t/_","70":"pages/totem-congratulations/index","71":"pages/update-order-items/_number","72":"pages/update-order-items/editable-line-item/EditableLineItem","73":"pages/user/spree_user/password/edit/index","74":"pages/user/spree_user/password/new/index","75":"pages/wishlist/index","76":"picture-input","77":"product-info-sections","78":"referralWidget","80":"spree-page","81":"stamped-io-feed","82":"stampedio","83":"stock-alert","84":"v-image","86":"vendors_gallery-component","87":"vendors_picture-input","88":"vendors_sentry"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.gocase.com.br/.nuxt/dist/client/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
